import { render, staticRenderFns } from "./RelationPointModal.vue?vue&type=template&id=5b4d3850&scoped=true"
import script from "./RelationPointModal.vue?vue&type=script&lang=js"
export * from "./RelationPointModal.vue?vue&type=script&lang=js"
import style0 from "./RelationPointModal.vue?vue&type=style&index=0&id=5b4d3850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d3850",
  null
  
)

export default component.exports